import { Injectable } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { EMPTY, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { JmlMenuItem } from '../models/JmlMenuItem'
import { MenuConfigService } from './menu-config.service'

@Injectable({
  providedIn: 'root'
})
export class CustomNavMenuService {
  constructor(private menuConfigService: MenuConfigService) {}

  buildMenuItem(jmlItem: JmlMenuItem, routePrefix: string): MenuItem {
    const menuItem: MenuItem = {}

    menuItem.label = jmlItem.name
    if (!jmlItem.children) {
      if (jmlItem.type) {
        const words = jmlItem.type.split(/(?=[A-Z])/).map((word) => word.toLocaleLowerCase())
        menuItem.routerLink = routePrefix + words.join('-')
      } else {
        menuItem.routerLink = [`${routePrefix}${jmlItem.dtoType}`]
      }
    }
    menuItem.icon = jmlItem.icon
    menuItem.items = jmlItem.children?.map((e) =>
      this.buildMenuItem(e, routePrefix + (jmlItem.route ? jmlItem.route + '/' : ''))
    )

    return menuItem
  }

  getCustomMenuItemTree(): Observable<MenuItem[]> {
    const obs$ =
      !!this.menuConfigService.lastMenuRequestResult$ && this.menuConfigService.lastMenuRequestResult$ !== EMPTY
        ? this.menuConfigService.lastMenuRequestResult$
        : this.menuConfigService.getMenuEntries()
    return obs$.pipe(map((menuItems) => menuItems?.map((e) => this.buildMenuItem(e, ''))))
  }
}
